<template>
    <div id="v-header" class="gradient-bg">
        <div class="header-wrap d-flex justify-content-between">
            <div class="head-left">
                <a href="/" class="logo">
                    <!-- logo start -->
                    <img :src="logo" alt="" />
                    <!-- logo start -->
                </a>
                <!-- 打开侧边栏按钮 -->
                <v-btn
                    :class="['sidenav-btn', triggerSideNavShow ? 'active' : '']"
                    @click.native="open_sidenav($event)"
                >
                    <v-icon v-if="!triggerSideNavShow"
                        >mdi-format-indent-decrease</v-icon
                    >
                    <v-icon v-else>mdi-format-indent-increase</v-icon>
                </v-btn>

                <div
                    class="search-wrap"
                    v-if="!$store.state.global.isNewBeveliver"
                >
                    <search />
                </div>
                <div id="google_translate_element"></div>
            </div>
            <div class="head-right">
                <!-- 多语言弹框按钮 -->
                <v-btn
                    :class="[
                        'language-btn',
                        $store.state.mixins.isLangType && 'active',
                    ]"
                    @click="dialog = true"
                >
                    <template v-if="isChangLang">
                        <i
                            class="flag"
                            :style="
                                'background-image:url(' +
                                currentLang.flag +
                                ');'
                            "
                        ></i>
                        <span class="country">{{ currentLang.name }}</span>
                    </template>
                    <template v-else>
                        <div class="v-spinner-border" />
                    </template>
                </v-btn>
                <!-- 最新更新 -->
                <v-btn
                    class="news-update-btn"
                    :class="[
                        'language-btn',
                        !$store.state.mixins.isLangType && 'active',
                    ]"
                    @click="get_latest_content"
                >
                    <i class="fire"></i>
                    {{ $TL.news }}
                </v-btn>
                <!-- 最新通知 -->
                <v-menu
                    class="new-notice-wrap"
                    offset-y
                    attach
                    left
                    v-model="newNotice"
                    @input="lates_notice_wrap"
                    :close-on-content-click="closeMenuBox"
                >
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            :class="[
                                'v-tooltips',
                                'new-notice-btn',
                                newTips && 'tip',
                            ]"
                            v-bind="attrs"
                            v-on="on"
                            @click="closeMenuBox = false"
                        >
                            <v-icon>mdi-bell-outline</v-icon>
                            <span class="v-tooltip__content">{{
                                $TL.notification
                            }}</span>
                        </v-btn>
                    </template>
                    <v-list class="new-notice-dropdown" v-if="hasMessage">
                        <latestNotice
                            @closeLatestNoticeBox="closeMenuBox = true"
                            :notify="basicInfo.ntfy"
                        />
                    </v-list>
                </v-menu>
                <!-- 用户使用规范 -->
                <v-menu class="manual-wrap" offset-y attach left>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn class="manual" v-bind="attrs" v-on="on">
                            {{ $TL.instructions }}
                            <v-icon>mdi-chevron-down</v-icon>
                        </v-btn>
                    </template>
                    <v-list
                        class="doropdown-content manual-doropdown"
                        v-if="basicInfo.instructions"
                    >
                        <ul class="select">
                            <li
                                v-for="(item, i) in basicInfo.instructions"
                                :key="i"
                            >
                                <router-link
                                    :to="{
                                        name: 'instructions',
                                        query: {
                                            docId: docid_compile(
                                                item.url.match(
                                                    /d\/(.*?)\/edit/
                                                )[1]
                                            ),
                                        },
                                    }"
                                    target="_blank"
                                    >{{ item.title }}</router-link
                                >
                            </li>
                        </ul>
                    </v-list>
                </v-menu>
                <!-- 用户反馈 -->
                <!-- <a :href="basicInfo.feedback" class="v-tooltips v-btn feedback" target="_blank">
          <v-icon>mdi-message-alert</v-icon>
          <span class="v-tooltip__content">{{ $TL.feedback }}</span>
        </a> -->

                <!-- 用户系统登录注册 -->
                <role-switch
                    :role="roles"
                    v-if="!$store.state.global.isNewBeveliver"
                />
            </div>
        </div>
        {{ $P.listContent }}

        <!-- 多语言弹框 -->
        <v-dialog content-class="language-dialog" v-model="dialog">
            <language-wrapper
                v-if="basicInfo.languages"
                :langs="basicInfo.languages"
                @closeModel="close_dialog_fn"
            />
            <v-btn class="close-dialog" @click="close_dialog_fn">
                <v-icon>mdi-close</v-icon>
            </v-btn>
        </v-dialog>
    </div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from "vuex";
import { get_storage, set_storage, compileStr, timeout } from "@/utils/util";
import Search from "@/components/search/index";
import latestNotice from "@/components/latest-notice/index";
import languageWrapper from "@/components/language-wrapper/index";
import roleSwitch from "@/components/role-switch/index";
export default {
    name: "v-header",

    data() {
        this.TIME = 24;
        return {
            logo: "./mgmedia/img/logo.png",
            sideNavShow: false,

            // 模拟数据
            flag: "",
            name: "",
            basicInfo: "",
            langsShow: false,
            closeMenuBox: false,
            dialog: false,
            roles: false,
            cont: 0,
            newNotice: true,
            newTips: true,
            hasMessage: null,
            isChangLang: false,
        };
    },
    computed: {
        ...mapState("global", [
            "globalBasicInfo",
            "currentLang",
            "isNewBeveliver",
        ]),
        ...mapState("mixins", ["triggerSideNavShow", "resetSideNav"]),
    },
    components: { Search, latestNotice, languageWrapper, roleSwitch },
    watch: {
        async currentLang() {
            this.isChangLang = false;
            await timeout(220);
            this.isChangLang = true;
        },
    },
    created() {
        //  如果是新人账号，第一次弹出语言弹框
        if (this.isNewBeveliver && !get_storage("langModeShow")) {
            this.dialog = true;
        }
        this.get_basic_info_data();

        this.sideNavShow = this.triggerSideNavShow;
        this.reopen_lates_notice_box();
    },
    mounted() {},
    methods: {
        ...mapMutations("mixins", ["updateOpenSideNav", "updateCurrentDoc"]),
        ...mapMutations("global", ["updateAccessLang"]),
        ...mapMutations("triggerEvtents", [
            "updateGetSchemaData",
            "updateInitSearchCondition",
            "updateResetFilterCondition",
        ]),
        ...mapMutations("search", ["updateFilterCondition"]),
        open_sidenav(ev) {
            let $el = $(ev.currentTarget);
            if ($el.hasClass("active")) {
                this.sideNavShow = false;
            } else {
                this.sideNavShow = true;
            }

            this.updateOpenSideNav({ show: this.sideNavShow, reset: false });
        },
        //  获取基础数据
        async get_basic_info_data() {
            this.basicInfo = this.globalBasicInfo;
            this.get_current_lang_flag(this.basicInfo.languages);
            this.hasMessage = this.basicInfo.ntfy?.message;
        },
        //  获取最新数据
        async get_latest_content() {
            //  如果用户在收藏页或收藏详情页
            this.$P.returnIndex(this);

            //  当前数据类型是否为按语言
            this.$store.state.mixins.isLangType = false;
            this.updateInitSearchCondition();
            this.$P.schemaType = "latestUpdate";
            this.updateFilterCondition([]);
            this.updateGetSchemaData();
            this.updateResetFilterCondition();
        },

        //  获取用户选择的默认语言
        get_current_lang_flag(language) {
            let [lang, flag, name] = [this.currentLang.lang, null, null];
            for (var prop in language) {
                language[prop].map((langs, i) => {
                    if (langs.code === lang) {
                        flag = langs.thumbnail;
                        name = langs.name;
                    }
                });
            }
            //  储存当前登录用户
            this.updateAccessLang({ lang, flag, name });
        },
        // 用户关闭最新通知弹框后在 storage 里储存当前时间
        lates_notice_wrap() {
            if (!this.newNotice) {
                set_storage("newNotice", this.new_time());
                this.newTips = false;
            }
        },
        //  创建当前小时
        new_time() {
            return Math.floor(new Date().getTime() / 3600000);
        },
        //  24hours 后重新开启最新通知
        reopen_lates_notice_box() {
            if (get_storage("newNotice")) {
                if (this.new_time() - this.TIME > get_storage("newNotice")) {
                    localStorage.removeItem("newNotice");
                    this.newNotice = this.newTips = true;
                } else {
                    this.newNotice = this.newTips = false;
                }
            }
        },
        docid_compile(docId) {
            if (!docId) {
                debugger
                console.log(
                    JSON.parse(JSON.stringify(this.basicInfo.instructions))
                );
            }
            return compileStr(docId);
        },
        close_dialog_fn() {
            this.dialog = false;
            set_storage("langModeShow", 1);
        },
    },
};
</script>

<style lang="scss">
#v-header {
    width: 100%;
    height: 64px;
    padding: 12px 24px;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    margin: auto;
    z-index: 1020;
    box-shadow: 0 1px 4px rgba(#001529, 0.12);

    .header-wrap {
        height: 100%;
    }

    .head-left,
    .head-right {
        height: 100%;
        @include flex(center);
    }

    .logo {
        height: 100%;
        flex-shrink: 0;

        img {
            max-height: 100%;
        }
    }

    .sidenav-btn {
        margin-left: 26px;
        border-radius: 50%;
        margin-top: -4px;
        color: $color-white;

        span {
            padding: 8px;
        }

        i {
            color: $color-white;
        }
    }

    .search-wrap {
        width: 730px;
        height: 40px;
        position: relative;
        margin-left: 46px;

        &::before {
            content: "";
            width: 2px;
            height: 80%;
            position: absolute;
            top: 0;
            bottom: 0;
            left: -30px;
            margin: auto;
            background-color: $color-white;
        }
    }

    .head-right {
        position: relative;

        .v-btn {
            height: 32px;

            i {
                color: $color-white;
            }

            font-size: 14px;
        }

        .language-btn,
        .news-update-btn,
        .registered-btn,
        .login-btn {
            min-width: 60px;
            border-radius: 32px;
        }

        .news-update-btn,
        .registered-btn {
            line-height: 1.2;
            padding: 4px 12px;
            color: $color-white;
        }

        .language-btn,
        .news-update-btn {
            &.active {
                background-color: $color-white;
                span {
                    color: #2874e5;
                }
            }
        }

        .news-update-btn {
            margin-left: 16px;
            border: 1px solid rgba($color-white, 0.8);

            .fire {
                display: inline-block;
                width: 15px;
                height: 20px;
                margin-right: 6px;
                background: {
                    image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAVCAYAAABPPm7SAAAABHNCSVQICAgIfAhkiAAAAatJREFUOE+VVN1RwmAQ3PvAZ+1ArEA6UN6cMYFQgVCBdGCsQKzAWIGBMI5vhg7oQOwg75icly/kj48o3ENmkny32d3bC+GPYsc5Q8xPABMF89G+o9TUr5t/+BOELpgfaTF3DwaoNaddRwNY/SmI7ssv8uvBEvjG6eCEv3boRmjRBfl+tCvD8IBv7QmUEuOM8iiYjf8HsPshQFcN5hogmgHb9gibVkgf/pqt/kr0XzZOl+GjTeNcDhWamXq08EO2BpGM7rQAYHzL/XkNkLESkF4KQoXmHMCQkAzByquBatrwaTEbEucNzM8Slonce+LBXcmAekgQQXFogggLtge8PaxHhTi+BtRbSTkZUxB44pNTf65pzKoAKa2VXIQuTUsGZYwNdoB4YA3WhklVx7bSttMyWJQeNM1tIwmU8WqA3ZDJhARAMgD1YvbzErGa0LsvsrIyMyI7kr3YK2ONhF0BWaKNjpx6EKlicKXS0WcAzjVIdv+oyja0WCYthZWscSWFjYC8lGbNpraNWawTtxakGuU01omb5iJ/vPeXlv0LJVBM3cw9jsCybBVDc4BfoU7W7hGxRygAAAAASUVORK5CYII=);
                    repeat: no-repeat;
                    position: center center;
                    size: cover;
                }
            }
        }

        .v-btn.feedback {
            height: 40px;
        }

        .feedback,
        .new-notice-btn {
            margin-left: 20px;
        }

        .new-notice-btn {
            border-radius: 50%;
            height: 40px;
            width: 40px;
            color: $color-white;
        }

        .manual {
            padding: 2px 6px 2px 12px;
            color: $color-white;
            border-radius: 32px;
        }

        .new-notice-btn {
            .v-btn__content {
                position: relative;
            }

            &.tip {
                .v-btn__content::before {
                    content: "";
                    display: block;
                    position: absolute;
                    right: 4px;
                    top: 6px;
                    z-index: 2;
                    width: 6px;
                    height: 6px;
                    border: 1px solid $color-white;
                    border-radius: 50%;
                    background-color: #ff4d4f;
                }
            }
        }

        .v-spinner-border {
            width: 22px;
            height: 22px;
        }
    }

    .user-instruct {
        .option-box {
            width: 246px;
        }
    }

    @media (max-width: 1650px) {
        .search-wrap {
            width: 600px;
        }
    }

    @media (max-width: 1460px) {
        .logo {
            height: 86%;
        }
        .search-wrap {
            width: 500px;
            margin-left: 32px;
            &::before {
                left: -20px;
            }
        }

        .sidenav-btn {
            margin-left: 16px;
        }

        .head-right {
            .news-update-btn,
            .manual {
                margin-left: 16px;
            }
        }

        .role-switch .user-portal {
            margin-left: 24px;
            &::before {
                left: -10px;
            }
        }
    }

    .new-notice-wrap {
        .v-menu__content {
            left: -162px !important;
        }
    }

    .new-notice-dropdown {
        padding-top: 4px;
        padding-bottom: 8px;
    }
}

.manual-doropdown {
    width: 264px;
}

// 处理google 自动翻译样式
.skiptranslate,
.goog-te-banner-frame {
    display: none !important;
}

.goog-text-highlight {
    background-color: inherit !important;
    box-shadow: none !important;
}

body {
    top: 0 !important;
}
</style>
